import { render, staticRenderFns } from "./HomeReview.vue?vue&type=template&id=b52861ac&scoped=true"
import script from "./HomeReview.vue?vue&type=script&lang=js"
export * from "./HomeReview.vue?vue&type=script&lang=js"
import style0 from "./HomeReview.vue?vue&type=style&index=0&id=b52861ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52861ac",
  null
  
)

export default component.exports